import React, { useState, useEffect } from 'react';
import HomeTopBar from './HomeTopBar';
import ProductPreferenceSavingsChart from '../charts/ProductPreference/ProductPreferenceSavingsChart';
import ProductPreferenceChequeChart from '../charts/ProductPreference/ProductPreferenceChequeChart';
import ProductPreferenceCreditCardChart from '../charts/ProductPreference/ProductPreferenceCreditCardChart';
import ProductPreferenceHomeLoanChart from '../charts/ProductPreference/ProductPreferenceHomeLoanChart';
import ProductPreferenceVehicleFinanceChart from '../charts/ProductPreference/ProductPreferenceVehicleFinanceChart';
import axios from 'axios';
import { provinces, local_market, province_market_map, segments } from '../constants';
import ProductPreferencePPTX from '../powerpoint/ProductPreferencePPTX';

const ProductPreferenceMarketShare = ({ heading, savings, cheque, credit_card, home_loan, vaf }) => {
  const [selectedProvince, setSelectedProvince] = useState('');
  const [selectedLocalMarket, setSelectedLocalMarket] = useState('');
  const [selectedSegment, setSelectedSegment] = useState('');
  const [localMarkets, setLocalMarkets] = useState([]);
  const [savingsData, setSavingsData] = useState([]);
  const [chequeData, setChequeData] = useState([]);
  const [creditCardData, setCreditCardData] = useState([]);
  const [homeLoanData, setHomeLoanData] = useState([]);
  const [vehicleFinanceData, setVehicleFinanceData] = useState([]);

  const handleProvinceChange = (e) => {
    const selectedProvince = e.target.value;
    setSelectedProvince(selectedProvince);

    if (selectedProvince && province_market_map[selectedProvince]) {
      setLocalMarkets(province_market_map[selectedProvince].local_markets);
    } else {
      setLocalMarkets([]);
    }
    setSelectedLocalMarket('');
  };

  const getProvinceValue = () => (selectedProvince ? provinces[selectedProvince] : '');
  const getLocalMarketValue = () => (selectedLocalMarket ? local_market[selectedLocalMarket] : '');
  const getSegmentValue = () => (selectedSegment ? segments[selectedSegment] : '');

  const fetchPreferenceData = async (preferenceType, setData) => {
    try {
      const provinceValue = getProvinceValue();
      const localMarketValue = getLocalMarketValue();

      const response = await axios.get(`https://outlook.plus94research.co.za/api/product_preference/${preferenceType}/`, {
        params: {
          province: provinceValue,
          local_market: localMarketValue,
          segment: selectedSegment  
        },
      });
      setData(response.data.chart_data);
    } catch (error) {
      console.error(`Error fetching data for ${preferenceType}:`, error);
      setData([]);
    }
  };

  useEffect(() => {
    fetchPreferenceData('savings', setSavingsData);
  }, [selectedProvince, selectedLocalMarket, selectedSegment]);

  useEffect(() => {
    fetchPreferenceData('cheque', setChequeData);
  }, [selectedProvince, selectedLocalMarket, selectedSegment]);

  useEffect(() => {
    fetchPreferenceData('credit_card', setCreditCardData);
  }, [selectedProvince, selectedLocalMarket, selectedSegment]);

  useEffect(() => {
    fetchPreferenceData('home_loan', setHomeLoanData);
  }, [selectedProvince, selectedLocalMarket, selectedSegment]);

  useEffect(() => {
    fetchPreferenceData('vehicle_finance', setVehicleFinanceData);
  }, [selectedProvince, selectedLocalMarket, selectedSegment]);

  return (
    <div className='home'>
      <HomeTopBar />
      <div className='three-charts-heading-div'>
        <h2 className='heading'>{heading}</h2>
      </div>

      <div className='filter'>
        <label htmlFor="province-select">Province: </label>
        <select
          id="province-select"
          value={selectedProvince}
          onChange={handleProvinceChange}
        >
          <option value="">All</option>
          {Object.keys(provinces).map((province) => (
            <option key={province} value={province}>
              {province}
            </option>
          ))}
        </select>

        <label htmlFor="local-market-select">Local Market: </label>
        <select
          id="local-market-select"
          value={selectedLocalMarket}
          onChange={(e) => setSelectedLocalMarket(e.target.value)}
          disabled={!selectedProvince || localMarkets.length === 0}
        >
          <option value="">All</option>
          {localMarkets.map((market, index) => (
            <option key={index} value={market}>
              {market}
            </option>
          ))}
        </select>

        <label htmlFor="segment-select">Segments: </label>
        <select
          id="segment-select"
          value={selectedSegment}
          onChange={(e) => setSelectedSegment(e.target.value)}
        >
          <option value="">All</option>
          {Object.keys(segments).map((segment) => (
            <option key={segment} value={segment}>
              {segment}
            </option>
          ))}
        </select>
      </div>

      <div>
        <ProductPreferencePPTX
          selectedProvince={selectedProvince}
          selectedLocalMarket={selectedLocalMarket}
          savingsData={savingsData}
          chequeData={chequeData}
          creditCardData={creditCardData}
          homeLoanData={homeLoanData}
          vehicleFinanceData={vehicleFinanceData}
        />
      </div>

      <div className='five-charts-container'>
        <div className='check-and-savings'>
          <div className='savings'>
            <h2 className='five-charts-heading'>{savings}</h2>
            <ProductPreferenceSavingsChart savingsData={savingsData} />
          </div>
          <div className='cheque'>
            <h2 className='five-charts-heading'>{cheque}</h2>
            <ProductPreferenceChequeChart chequeData={chequeData} />
          </div>
        </div>

        <div className='credit-card-and-home-loan'>
          <div className='credit-card'>
            <h2 className='five-charts-heading'>{credit_card}</h2>
            <ProductPreferenceCreditCardChart data={creditCardData} />
          </div>
          <div className='home-loan'>
            <h2 className='five-charts-heading'>{home_loan}</h2>
            <ProductPreferenceHomeLoanChart data={homeLoanData} />
          </div>
        </div>

        <div className='vaf-div'>
          <div className='vaf'>
            <h2 className='five-charts-heading'>{vaf}</h2>
            <ProductPreferenceVehicleFinanceChart data={vehicleFinanceData} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductPreferenceMarketShare;

